// Final.tsx
import EliminatoriaCompartida from "./EliminatoriaCompartida";

const Final = () => (
  <EliminatoriaCompartida
    fase="final"
    titulo="Final y 3° Puesto"
    endpoint="/final/partidos"
    fechaPrimerPartido="2026-07-18T18:00:00"
  />
);

export default Final;
